import { Link } from 'react-router-dom'
import { Card, Button } from '@/components/ui'
import { Header, Footer } from '@/components/layout'

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-neutral-50">
      <Header />

      <main className="flex-1 w-full max-w-2xl mx-auto px-4 py-8 md:py-12">
        <div className="fade-in">
          <Card variant="elevated" padding="lg">
            <div className="text-center py-8">
              {/* Icon */}
              <div className="w-20 h-20 mx-auto mb-6 bg-neutral-100 flex items-center justify-center">
                <svg
                  className="w-10 h-10 text-neutral-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>

              {/* Title */}
              <h3 className="text-neutral-900 mb-3">Page Not Found</h3>

              {/* Message */}
              <p className="text-neutral-600 max-w-md mx-auto mb-6">
                The page you're looking for doesn't exist or has been moved.
                If you have a payment link, please use that link directly.
              </p>

              {/* Actions */}
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-6">
                <Link to="/">
                  <Button variant="primary" size="lg">
                    Go to Home
                  </Button>
                </Link>
                <a href="https://nestrentalapartments.com">
                  <Button variant="secondary" size="lg">
                    Go to NEST Website
                  </Button>
                </a>
              </div>
            </div>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  )
}
